import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http/http-client.service';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class AlteracaoUsuarioBackofficeService {

  constructor(
    private httpService: HttpService
  ) { }

  buscaUser(path:any, data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doGet('/backoffice/'+path, data, successHandle, errorHandle);

  }

  userBackoffice(path:any, data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doPatch('/backoffice/'+path, data, successHandle, errorHandle);

  } 
 

}
